import { render } from "./Complaint_Type.vue?vue&type=template&id=5e7bebaf"
import script from "./Complaint_Type.vue?vue&type=script&lang=js"
export * from "./Complaint_Type.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__